// extracted by mini-css-extract-plugin
module.exports = {"title":"countryTable_title__3eIA7","fullWidth":"countryTable_fullWidth__2xVuY"};